import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { getHolidaysEstablishment } from "../../../../../_api/Holiday";
import { InputForm } from "../../../../../_helpers/components/Forms/InputLabel";
import { Button } from "../../../../../_helpers/components/Button";
import { Table } from "../../../../../_helpers/Table";
import { SideBar } from "../../../../../_helpers/components/SideBar";
import { attachHoliday, deleteHoliday } from "../../../../../_api/Holiday";
import toast from "react-hot-toast";
import { DefaultDropdown } from "../../../../../_helpers/components/Forms/Dropdown";
import { Toggle } from "../../../../../_helpers/components/Forms/ToggleButton";
import { dateToAAAAMMJJ } from "../../../../../_helpers/functions";

function getEasterDate(year) {
    const f = Math.floor,
        G = year % 19,
        C = f(year / 100),
        H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
        I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
        J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
        L = I - J,
        month = 3 + f((L + 40) / 44),
        day = L + 28 - 31 * f(month / 4);

    return new Date(year, month - 1, day);
}

function getNextEasterSunday() {
    const now = new Date();
    let year = now.getFullYear();
    let easterSunday = getEasterDate(year);
    if (easterSunday < now) {
        year++;
        easterSunday = getEasterDate(year);
    }
    return easterSunday;
}

function getNextEasterMonday() {
    const now = new Date();
    let year = now.getFullYear();
    let easterSunday = getEasterDate(year);
    let easterMonday = new Date(easterSunday);
    easterMonday.setDate(easterSunday.getDate() + 1);

    if (easterMonday < now) {
        // Si c'est déjà passé cette année, on prend l'année prochaine
        year += 1;
        easterSunday = getEasterDate(year);
        easterMonday = new Date(easterSunday);
        easterMonday.setDate(easterSunday.getDate() + 1);
    }

    return easterMonday;
}

function getNextPentecostMonday() {
    const now = new Date();
    let year = now.getFullYear();
    let easterSunday = getEasterDate(year);
    let pentecostMonday = new Date(easterSunday);
    pentecostMonday.setDate(easterSunday.getDate() + 50);

    if (pentecostMonday < now) {
        year += 1;
        easterSunday = getEasterDate(year);
        pentecostMonday = new Date(easterSunday);
        pentecostMonday.setDate(easterSunday.getDate() + 50);
    }

    return pentecostMonday;
}

function getNextAscension() {
    const now = new Date();
    let year = now.getFullYear();
    let ascension = new Date(getEasterDate(year));
    ascension.setDate(ascension.getDate() + 39);

    if (ascension < now) {
        year++;
        ascension = new Date(getEasterDate(year));
        ascension.setDate(ascension.getDate() + 39);
    }

    return ascension;
}
const joursFeries = [
    {
        value: "AN",
        label: "Jour de l'an",
        isFixed: true,
        next_date:
            new Date() > new Date(new Date().getFullYear(), 0, 1)
                ? new Date(new Date().getFullYear() + 1, 0, 1)
                : new Date(new Date().getFullYear(), 0, 1),
    },
    {
        value: "TRAVAIL",
        label: "Fête du travail",
        isFixed: true,
        next_date:
            new Date() > new Date(new Date().getFullYear(), 4, 1)
                ? new Date(new Date().getFullYear() + 1, 4, 1)
                : new Date(new Date().getFullYear(), 4, 1),
    },
    {
        value: "1945",
        label: "Victoire 1945",
        isFixed: true,
        next_date:
            new Date() > new Date(new Date().getFullYear(), 4, 8)
                ? new Date(new Date().getFullYear() + 1, 4, 8)
                : new Date(new Date().getFullYear(), 4, 8),
    },
    {
        value: "nationale",
        label: "Fête Nationale",
        isFixed: true,
        next_date:
            new Date() > new Date(new Date().getFullYear(), 6, 14)
                ? new Date(new Date().getFullYear() + 1, 6, 14)
                : new Date(new Date().getFullYear(), 6, 14),
    },
    {
        value: "toussaint",
        label: "Toussaint",
        isFixed: true,
        next_date:
            new Date() > new Date(new Date().getFullYear(), 10, 1)
                ? new Date(new Date().getFullYear() + 1, 10, 1)
                : new Date(new Date().getFullYear(), 10, 1),
    },
    {
        value: "1918",
        label: "Armistice 1918",
        isFixed: true,
        next_date:
            new Date() > new Date(new Date().getFullYear(), 10, 11)
                ? new Date(new Date().getFullYear() + 1, 10, 11)
                : new Date(new Date().getFullYear(), 10, 11),
    },
    {
        value: "Assomption",
        label: "Assomption",
        isFixed: true,
        next_date:
            new Date() > new Date(new Date().getFullYear(), 7, 15)
                ? new Date(new Date().getFullYear() + 1, 7, 15)
                : new Date(new Date().getFullYear(), 7, 15),
    },
    {
        value: "noel",
        label: "Noël",
        isFixed: true,
        next_date:
            new Date() > new Date(new Date().getFullYear(), 11, 25)
                ? new Date(new Date().getFullYear() + 1, 11, 25)
                : new Date(new Date().getFullYear(), 11, 25),
    },
    {
        value: "Ascension",
        label: "Ascension",
        isFixed: false,
        next_date: getNextAscension(),
    },
    {
        value: "pentecote",
        label: "Pentecôte",
        isFixed: false,
        next_date: getNextPentecostMonday(),
    },
    {
        value: "dimanche_paques",
        label: "Pâques",
        isFixed: false,
        next_date: getNextEasterSunday(),
    },
    {
        value: "paques",
        label: "Lundi de Pâques",
        isFixed: false,
        next_date: getNextEasterMonday(),
    },
    {
        value: "others",
        label: "Autre",
        isFixed: true,
        next_date: new Date(),
    },
];

const HolidaysForm = (props) => {
    const { holiday, closeModal, refreshData } = props;
    const { establishment_id } = useParams();

    const [name, setName] = useState(holiday?.label || "");

    const [selectedDate, setSelectedDate] = useState(
        joursFeries.find((jf) => jf.value === holiday?.dropdown_value) || null
    );
    const [recurring, setRecurring] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const _add = () => {
        const payload = {
            name: selectedDate?.value === "others" ? name : selectedDate?.label,
            day: new Date(selectedDate?.next_date).getDate(),
            month: new Date(selectedDate?.next_date).getMonth() + 1,
            year: recurring ? null : new Date(selectedDate?.next_date).getFullYear(),
            dropdown_value: selectedDate?.value,
            type: selectedDate?.isFixed ? "FIXED" : "VARIABLE",
        };
        setIsSaving(true);
        attachHoliday(establishment_id, payload)
            .then((resp) => {
                toast(resp.data.message);
                closeModal();
                refreshData();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => setIsSaving(false));
    };

    const _edit = () => {
        closeModal();
        refreshData();
    };

    const setCurrentDayOff = (date) => {
        setSelectedDate({
            value: "others",
            label: name,
            isFixed: true,
            next_date: date,
        });
    };

    useEffect(() => {
        if (!holiday) {
            setSelectedDate(joursFeries[0]);
        }
    }, []);

    return (
        <>
            <div className="flex flex-wrap -mx-2">
                <div className="w-full px-2 mb-3">
                    <DefaultDropdown
                        options={joursFeries}
                        name="Jours fériés"
                        required={true}
                        value={selectedDate?.value}
                        onChange={(e) => {
                            const selectCycle = joursFeries.find((option) => {
                                return (
                                    option.value.toString() ===
                                    e.target.value.toString()
                                );
                            });
                            setSelectedDate(selectCycle);
                        }}
                    />
                </div>
                {selectedDate?.value === "others" && (
                    <div className="w-full px-2 mb-3">
                        <InputForm
                            name="Nom"
                            value={name}
                            placeholder="Nom"
                            type="text"
                            set={setName}
                            required={true}
                        />
                    </div>
                )}
            </div>
            <div className="flex flex-wrap -mx-2">
                <div className="w-full px-2 mb-3">
                    {selectedDate?.value === "others" && (
                        <Toggle
                            name="Chaque année ?"
                            enabled={recurring}
                            setEnabled={() => setRecurring(!recurring)}
                        />
                    )}
                </div>
            </div>
            <div className="flex flex-wrap -mx-2">
                <div className="w-full px-2 mb-3">
                    <InputForm
                        name={
                            selectedDate?.value === "others"
                                ? "Date"
                                : "Prochaine date"
                        }
                        value={dateToAAAAMMJJ(selectedDate?.next_date ? selectedDate.next_date : new Date(), "-")}
                        type={
                            selectedDate?.value === "others" && recurring
                                ? "daymonth"
                                : "date"
                        }
                        readOnly={
                            selectedDate?.value === "others" ? false : true
                        }
                        set={setCurrentDayOff}
                        required={true}
                    />
                </div>
            </div>
            <div className="flex justify-end">
                <div className="m-1">
                    <Button
                        id="add"
                        type={"empty"}
                        action={() => {
                            closeModal();
                        }}
                        name="Annuler"
                    />
                </div>
                <div className="m-1">
                    <Button
                        id="add"
                        action={() => (holiday ? _edit() : _add())}
                        name={holiday ? "Modifier" : "Ajouter"}
                        loading={!holiday && isSaving}
                    />
                </div>
            </div>
        </>
    );
};

export const HolidaysTab = (props) => {
    const { currentApp, currentMenu, currentTab, user } = props;
    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["COMPANY"]["features"];

    const navigate = useNavigate();
    const { establishment_id } = useParams();
    const [holidays, setHolidays] = useState([]);
    const [deletingHolidayId, setDeletingHolidayId] = useState(null);

    const [openSideBar, setOpenSidebar] = useState(false);
    const [sideBarTitle, setSidebarTitle] = useState("");
    const [sideBarContent, setSidebarContent] = useState("");
    const [isAddingFrenchHolidays, setIsAddingFrenchHolidays] = useState(false);
    const addingFrenchHolidaysRef = useRef(false);

    const loadHolidays = async () => {
        await getHolidaysEstablishment(establishment_id).then((resp) => {
            setHolidays(resp.data);
        });
    };

    const _delete = (holiday_id) => {
        if (deletingHolidayId !== null) {
            return;
        }
        setDeletingHolidayId(holiday_id);
        deleteHoliday(establishment_id, holiday_id)
            .then((resp) => {
                toast(resp.data.message);
            })
            .catch((err) => {
                toast(
                    err?.response?.data?.message ?? "Impossible de supprimer"
                );
            })
            .finally(() => {
                setDeletingHolidayId(null);
                loadHolidays();
            });
    };

    const tableRows = useMemo(() => {
        return holidays.map((res) => {
            const test = joursFeries.find(
                (jf) => jf.value === res.dropdown_value
            );
            if (test.value === "others") {
                if (res.year) {
                    test.next_date = new Date(res.year, res.month - 1, res.day);
                } else {
                    test.next_date = new Date(
                        new Date().getFullYear(),
                        res.month - 1,
                        res.day
                    );
                    if (test.next_date < new Date()) {
                        test.next_date = new Date(
                            new Date().getFullYear() + 1,
                            res.month - 1,
                            res.day
                        );
                    }
                }
            }

            const isDeleting = deletingHolidayId === res.id;

            return {
                row: [
                    res.label,
                    test.next_date.toLocaleDateString("fr-FR", {
                        timeZone: "Europe/Paris",
                    }),
                    <button
                        key="delete"
                        type="button"
                        disabled={isDeleting}
                        onClick={(e) => {
                            e.stopPropagation();
                            _delete(res.id);
                        }}
                        className="text-red-600 hover:text-red-800 transition-colors disabled:pointer-events-none disabled:opacity-60"
                        title="Supprimer"
                        aria-busy={isDeleting ? true : undefined}
                    >
                        {isDeleting ? (
                            <span
                                className="inline-block h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-current border-r-transparent"
                                aria-hidden
                            />
                        ) : (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-4 h-4"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                />
                            </svg>
                        )}
                    </button>,
                ],
                data: res,
            };
        });
    }, [holidays, deletingHolidayId, establishment_id]);

    useEffect(() => {
        loadHolidays();
    }, [establishment_id]);

    const addHolidays = (value) => {
        setSidebarTitle("Ajouter un jour férié");
        setSidebarContent(
            <HolidaysForm
                holiday={value}
                closeModal={() => setOpenSidebar(false)}
                refreshData={loadHolidays}
            />
        );
        setOpenSidebar(true);
    };

    const addFrenchHolidays = () => {
        if (addingFrenchHolidaysRef.current) {
            return;
        }
        addingFrenchHolidaysRef.current = true;
        setIsAddingFrenchHolidays(true);

        const requests = joursFeries
            .filter((jf) => jf.value !== "others")
            .map((jf) => {
                const payload = {
                    name: jf.label,
                    day: new Date(jf.next_date).getDate(),
                    month: new Date(jf.next_date).getMonth() + 1,
                    year: null,
                    dropdown_value: jf.value,
                    type: jf.isFixed ? "FIXED" : "VARIABLE",
                };
                return attachHoliday(establishment_id, payload);
            });

        Promise.allSettled(requests)
            .then((results) => {
                results.forEach((result) => {
                    if (result.status === "rejected") {
                        const err = result.reason;
                        toast(
                            err?.response?.data?.message ??
                                "Une erreur est survenue"
                        );
                    }
                });
            })
            .finally(() => {
                addingFrenchHolidaysRef.current = false;
                setIsAddingFrenchHolidays(false);
                loadHolidays();
            });
    };

    return (
        <div>
            <div className="flex justify-end gap-2">
                <Button
                    name={"Ajouter les jours fériés français"}
                    type={"empty"}
                    isVisible={features_right['add_day_off']}
                    loading={isAddingFrenchHolidays}
                    action={addFrenchHolidays}
                />
                <Button
                    name={"+"}
                    type={"empty"}
                    isVisible={features_right['add_day_off']}
                    action={() => addHolidays(null)}
                />
            </div>

            <Table
                name={"Jours férié[s]"}
                // headers={["Nom", "Fixe/Variable", "Prochaine date"]}
                headers={["Nom", "Prochaine date", ""]}
                rows={tableRows}
                // onClick={addFrenchHolidays}
            />
            <SideBar
                title={sideBarTitle}
                content={sideBarContent}
                isOpen={openSideBar}
                onClose={() => {
                    setOpenSidebar(false);
                }}
            />
        </div>
    );
};
